export const initialState = {
  products: null,
  isLoadingProducts: false,
  retailers: null,
  currentRetailer: null,
  countProducts: 0,
  isGtinError: false,
  isLoadingRetailers: false,
  ocrRetailers: null,
  currentOCRRetailer: null,
  isLoadingOCRRetailer: false,
  sameProducts: null,
  prices: null,
  isLoadingPricesOrSames: false,
  isUpdatedProduct: null,
  currentProductId: null,
  gtins: null,
  isLoadingGtins: false,
  isUpdatedSameProduct: false,
  isPrdouctDeleting: false,
  isLoadingBrands: false,
  retailerBrands: null,
  isUpdatePriceSuccess: false,
  isSuccessUpdatedProduct: false,
  isUpdating: false,
  deletingRetailerId: null,
  participants: null,
  isLoadingParticipants: false,
  currRetailer: null,
  exportLink: null,
  downloadLink: null,
  isLoadingImport: false,
  isUpdatedImport: false,
  importLink: null,
  currentStoreId: null,
  isLoadingSameImport: false,
  isUpdatedSameImport: false,
  importSameLink: null,
  isLoadingStoreIds: false,
  storeIds: null
}

export const getProducts = state => state.pam.products || initialState.products

export const getRetailers = state => state.pam.retailers || initialState.retailers

export const getRetailersV2 = state => state.pam.retailers || initialState.retailers

export const getParticipantsOptions = state => state.pam.participants || initialState.participants

export const getLinkExport = state => state.pam.exportLink || initialState.exportLink

export const getLinkImport = state => state.pam.importLink || initialState.importLink

export const getLinkImportSame = state => state.pam.importSameLink || initialState.importSameLink

export const getCurrentRetailer = state => state.pam.currentRetailer || initialState.currentRetailer
